import { render } from "./ServiceUserList.vue?vue&type=template&id=72f78a14"
import script from "./ServiceUserList.vue?vue&type=script&lang=js"
export * from "./ServiceUserList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__